
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire244a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire244a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $ad65c29589d9db55$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["d7mkx","index.207b4de4.js","f5oBp","Task.63746f94.png","698oS","TaskActive.711fde5b.png","jXXnK","completed.d4654388.png","7sdC7","completedActive.0322ee1b.png","6GIca","pending.c4363b8b.png","7Ogtv","pendingActive.7500625b.png","b1hHs","delete.ddbf7545.png","5IpoN","deleteActive.a5c7a976.png","iaSyP","noun-add-4644662.6f016f3d.png","aFOpY","trash-icon.f06207bb.svg","a05xs","noun-deleted-4644672.dca42b0f.png","8n9DW","noun-correct-4644680.bb3937c7.png","lfUop","noun-history-4644679.b9f521a2.png","7R18g","Close.b277ea6d.png"]'));

const $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be = {
    taskLists: [],
    recentDeleted: [],
    completedTask: [],
    currentTime: Date.now()
};
const $d7fcaaa29d0ffaa7$export$a4281dcfe4be938d = function(task) {
    $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.push(task);
    $d7fcaaa29d0ffaa7$var$updateapplicationState();
};
const $d7fcaaa29d0ffaa7$var$updateapplicationState = function() {
    localStorage.setItem("applicationState", JSON.stringify($d7fcaaa29d0ffaa7$export$4ed7a3435bd201be));
};
const $d7fcaaa29d0ffaa7$export$9a487a26f79786f3 = function(element) {
    element.classList.toggle("hidden");
};
const $d7fcaaa29d0ffaa7$export$f08d315250e1aa23 = function(id) {
    const toBeDeleteID = $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.findIndex((task)=>task.id === id);
    const [recentlyDeleted] = $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.splice(toBeDeleteID, 1);
    $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.recentDeleted.push(recentlyDeleted);
    $d7fcaaa29d0ffaa7$var$updateapplicationState();
};
const $d7fcaaa29d0ffaa7$export$f9b8f6c708100712 = function(taskProvided) {
    const toBeCompletedID = $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.find((task)=>{
        if (task.id === taskProvided.id) {
            task.completed = true;
            task.pending = false;
            return task;
        }
    });
    $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.completedTask.push(toBeCompletedID);
    $d7fcaaa29d0ffaa7$var$updateapplicationState();
};
const $d7fcaaa29d0ffaa7$export$2adf6238a2d0dafa = function(task) {
    if ($d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.currentTime - task.timestamp > 34000) {
        const time = new Date($d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.currentTime - task.timestamp).getSeconds();
        return task;
    }
};
const $d7fcaaa29d0ffaa7$var$init = function() {
    const loadApplicationString = localStorage.getItem("applicationState");
    const loadApplicationState = JSON.parse(loadApplicationString);
    if (loadApplicationState) {
        $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists = loadApplicationState.taskLists;
        $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.recentDeleted = loadApplicationState.recentDeleted;
        $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.completedTask = loadApplicationState.completedTask;
    }
};
//prettier-ignore
const $d7fcaaa29d0ffaa7$var$clearLocalStorage = function() {
    localStorage.clear();
};
// clearLocalStorage();
$d7fcaaa29d0ffaa7$var$init();


class $bee5f140897ff5dc$var$FormWindowView {
    #element = document.querySelector(".formwindow");
    #dataContainer = document.querySelector(".formcontainer");
    #triggerButton = document.querySelector(".addTask");
    #closeButton = document.querySelector(".close");
    #createTask = document.querySelector(".appendTask");
    #inputs = document.querySelectorAll("input,textarea");
    addhandlerClick(handler) {
        this._clickListener(this.#triggerButton, handler);
        //  this._clickListener(this.#element, handler);
        this._clickListener(this.#closeButton, handler);
        this._keydownlistener(this.#element, handler);
    }
    _clickListener(element, handler, eventTarget = this.#element) {
        element.addEventListener("click", (e)=>{
            if (element === this.#closeButton) e.stopPropagation();
            handler(eventTarget);
        });
    }
    _keydownlistener(eventTarget, handler) {
        window.addEventListener("keydown", (e)=>{
            if (e.ctrlKey && e.key === "b") {
                if (eventTarget.classList.contains("hidden")) handler(eventTarget);
            }
        });
    }
    addTaskHandler(handler) {
        this.#createTask.addEventListener("click", (e)=>{
            e.preventDefault();
            const timestamp = Date.now();
            const notificationTime = timestamp + 86400;
            const formData = Object.fromEntries(this._generateTaskData());
            formData.id = timestamp;
            formData.timestamp = timestamp;
            formData.notificationTime = notificationTime;
            formData.pending = true;
            handler(formData);
            this._clearForm(this.#inputs);
            this.#element.classList.add("hidden");
        });
    }
    _generateTaskData() {
        const formData = new FormData(this.#dataContainer);
        return formData.entries();
    }
    _clearForm(formInputs) {
        formInputs.forEach((input)=>input.value = "");
    }
}
var $bee5f140897ff5dc$export$2e2bcd8739ae039 = new $bee5f140897ff5dc$var$FormWindowView();


// Import images
var $a41bdb974cfd1f54$exports = {};
$a41bdb974cfd1f54$exports = new URL("Task.63746f94.png", import.meta.url).toString();


var $cfe172a47f1face6$exports = {};
$cfe172a47f1face6$exports = new URL("TaskActive.711fde5b.png", import.meta.url).toString();


var $b417b55b784676d6$exports = {};
$b417b55b784676d6$exports = new URL("completed.d4654388.png", import.meta.url).toString();


var $203640c3ecbee427$exports = {};
$203640c3ecbee427$exports = new URL("completedActive.0322ee1b.png", import.meta.url).toString();


var $7cb4f88c80bf6bf3$exports = {};
$7cb4f88c80bf6bf3$exports = new URL("pending.c4363b8b.png", import.meta.url).toString();


var $352984d9372a4a88$exports = {};
$352984d9372a4a88$exports = new URL("pendingActive.7500625b.png", import.meta.url).toString();


var $4bb7987c26eb38ab$exports = {};
$4bb7987c26eb38ab$exports = new URL("delete.ddbf7545.png", import.meta.url).toString();


var $6e234cd1c09a6c37$exports = {};
$6e234cd1c09a6c37$exports = new URL("deleteActive.a5c7a976.png", import.meta.url).toString();


class $eea0cfd44b04b5f1$var$PanelView {
    #parentElement = document.querySelector(".states");
    addhandlerClick() {
        this.#parentElement.addEventListener("click", (e)=>{
            const allButtons = Array.from(this.#parentElement.querySelectorAll(".menu_item"));
            const clicked = e.target.closest(".menu_item");
            if (!clicked) return;
            allButtons.forEach((button)=>{
                const image = button.querySelector("img");
                const activeImage = button.dataset.active;
                const defaultImage = button.dataset.default;
                // Dynamically set the src based on the imported images
                if (button === clicked) {
                    image.src = this.getImageSrc(activeImage);
                    clicked.classList.add("active");
                    return;
                }
                image.src = this.getImageSrc(defaultImage);
                button.classList.remove("active");
            });
        });
    }
    getImageSrc(imageName) {
        const imageMap = {
            "src/images/Task.png": (0, (/*@__PURE__*/$parcel$interopDefault($a41bdb974cfd1f54$exports))),
            "src/images/TaskActive.png": (0, (/*@__PURE__*/$parcel$interopDefault($cfe172a47f1face6$exports))),
            "src/images/completed.png": (0, (/*@__PURE__*/$parcel$interopDefault($b417b55b784676d6$exports))),
            "src/images/completedActive.png": (0, (/*@__PURE__*/$parcel$interopDefault($203640c3ecbee427$exports))),
            "src/images/pending.png": (0, (/*@__PURE__*/$parcel$interopDefault($7cb4f88c80bf6bf3$exports))),
            "src/images/pendingActive.png": (0, (/*@__PURE__*/$parcel$interopDefault($352984d9372a4a88$exports))),
            "src/images/delete.png": (0, (/*@__PURE__*/$parcel$interopDefault($4bb7987c26eb38ab$exports))),
            "src/images/deleteActive.png": (0, (/*@__PURE__*/$parcel$interopDefault($6e234cd1c09a6c37$exports)))
        };
        return imageMap[imageName] || ""; // Default to empty string if not found
    }
}
var $eea0cfd44b04b5f1$export$2e2bcd8739ae039 = new $eea0cfd44b04b5f1$var$PanelView();


class $d56741b663388f29$var$View {
    #parentView = document.querySelector(".taskView");
    #data;
    render(data) {
        this.#data = data;
        if (Object.keys(data).length === 0) {
            const errorHTML = this._renderError();
            this._clear(this.#parentView);
            this.#parentView.insertAdjacentHTML("afterbegin", errorHTML);
            return;
        }
        this._clear(this.#parentView);
        const markup = data.map(this._generateTaskMarkup).join("");
        this.#parentView.insertAdjacentHTML("afterbegin", markup);
    }
    _clear(element) {
        element.innerHTML = "";
    }
}
var $d56741b663388f29$export$2e2bcd8739ae039 = $d56741b663388f29$var$View;


var $aa3fe6b9a73c053f$exports = {};
$aa3fe6b9a73c053f$exports = new URL("noun-add-4644662.6f016f3d.png", import.meta.url).toString();


var $0a8d401b001bd83f$exports = {};
$0a8d401b001bd83f$exports = new URL("trash-icon.f06207bb.svg", import.meta.url).toString();


class $d81f96baf221c9f7$var$allView extends (0, $d56741b663388f29$export$2e2bcd8739ae039) {
    #triggerElement = document.querySelector(".all");
    #data = [];
    addHandlerLoad(handler) {
        window.addEventListener("load", ()=>{
            handler();
        });
    }
    addHandlerAll(handler) {
        this.#triggerElement.addEventListener("click", ()=>{
            if (this.#data == []) this._renderError();
            else handler();
        });
    }
    _generateTaskMarkup(task) {
        return `
          <div class="task">
            <div class="icons">
             <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              x="0px"
              y="0px"
              viewBox="-5.0 -10.0 110.0 135.0"
              enable-background="new 0 0 100 100"
              xml:space="preserve"
              ${task.completed ? `stroke="none" fill="green" ` : `stroke="gray" fill="transparent" `}
              stroke-width="8px"
              width="30px"
              height="30px"
              class="complete"
            >
              <path
                d="M50,3C24.0844097,3,3,24.0844097,3,50s21.0844097,47,47,47c25.9163284,0,47-21.0844116,47-47S75.9163284,3,50,3z   M75.7727127,37.8906784L47.1550369,68.4529037C46.2999954,69.3627243,45.1081161,70,43.8592339,70  c-0.0059242,0-0.0125847,0-0.0185204,0c-1.2422066,0-2.4303856-0.6215439-3.2883873-1.5195236L24.2539387,51.3671761  c-1.7352581-1.8166885-1.6701126-4.7241325,0.1458378-6.4593887c1.8166904-1.7337761,4.6964474-1.6836281,6.4309635,0.1315804  l12.9825954,13.5796394l25.3292732-26.9548759c1.7204514-1.8285351,4.5972443-1.9243584,6.4302216-0.2009449  C77.4028473,33.1836357,77.491684,36.0599213,75.7727127,37.8906784z"
              />
            </svg>
              <img src="${0, (/*@__PURE__*/$parcel$interopDefault($0a8d401b001bd83f$exports))}" alt="" class="delete" />
            </div>
            <h1>${task.text}</h1>
          </div>
     `;
    }
    _renderError() {
        return `
    <div class="error">
          <img src="${0, (/*@__PURE__*/$parcel$interopDefault($aa3fe6b9a73c053f$exports))}" alt="" width="100px" />
          <h1>
            You haven't added<br />
            any tasks yet!
          </h1>
        </div>`;
    }
}
var $d81f96baf221c9f7$export$2e2bcd8739ae039 = new $d81f96baf221c9f7$var$allView();


class $e659f5f158f1f197$var$DeleteView {
    #parentElement = document.querySelector(".taskView");
    addHandlerDelete(handler) {
        this.#parentElement.addEventListener("click", function(e) {
            const deleteButton = e.target.closest(".delete");
            if (!deleteButton) return;
            const taskElement = deleteButton.closest(".task");
            const taskText = taskElement.querySelector("h1").textContent;
            taskElement.remove();
            handler(taskText);
        });
    }
}
var $e659f5f158f1f197$export$2e2bcd8739ae039 = new $e659f5f158f1f197$var$DeleteView();



var $0cca7284da0723f6$exports = {};
$0cca7284da0723f6$exports = new URL("noun-deleted-4644672.dca42b0f.png", import.meta.url).toString();


class $dccd2ef3a9b1f20b$var$RecentlyDeletedView extends (0, $d56741b663388f29$export$2e2bcd8739ae039) {
    #triggerElement = document.querySelector(".deleted");
    #data;
    addHandlerDelete(handler) {
        if (this.#triggerElement) this.#triggerElement.addEventListener("click", ()=>{
            handler();
        });
    }
    _generateTaskMarkup(task) {
        return `
          <div class="task">
            <div class="icons">
            <svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="30px" viewBox="0 0 100 125" style="enable-background:new 0 0 100 100;" xml:space="preserve"><path d="M42.3,16.8l12.1-3.6l-0.4-1.3c-0.2-0.7-0.7-1.2-1.3-1.6c-0.4-0.2-0.8-0.3-1.2-0.3c-0.3,0-0.5,0-0.8,0.1l-7,2.1  c-1.4,0.4-2.2,1.9-1.8,3.3L42.3,16.8z"/><path d="M24.1,29.1l52.2-15.6L76,12.8c-0.5-1.5-1.9-2.5-3.4-2.5c-0.3,0-0.7,0-1,0.2l-22.7,6.8l-7.1,2.1c0,0,0,0,0,0l-15.5,4.7  c-1.9,0.5-2.9,2.5-2.4,4.4L24.1,29.1z"/><path d="M75.4,79.3V33.7c0-0.6-0.5-1.1-1.1-1.1H26.4c-0.6,0-1.1,0.5-1.1,1.1v45.6c0,5.9,4.8,10.7,10.6,10.7h28.8  C70.6,90,75.4,85.2,75.4,79.3z M40.6,73.3c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1V43.8c0-0.6,0.5-1.1,1.1-1.1  c0.6,0,1.1,0.5,1.1,1.1V73.3z M51.5,73.3c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1V43.8c0-0.6,0.5-1.1,1.1-1.1  c0.6,0,1.1,0.5,1.1,1.1V73.3z M62.4,73.3c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1V43.8c0-0.6,0.5-1.1,1.1-1.1  c0.6,0,1.1,0.5,1.1,1.1V73.3z"/>
            </div>
            <h1>${task.text}</h1>
          </div>
     `;
    }
    _renderError() {
        return `
    <div class="error">
          <img src="${0, (/*@__PURE__*/$parcel$interopDefault($0cca7284da0723f6$exports))}" alt="" width="100px" />
          <h1>
            You haven't deleted <br />
            any tasks yet!
          </h1>
        </div>`;
    }
}
var $dccd2ef3a9b1f20b$export$2e2bcd8739ae039 = new $dccd2ef3a9b1f20b$var$RecentlyDeletedView();



class $eba8adcaf02651a4$var$notificationView extends (0, $d56741b663388f29$export$2e2bcd8739ae039) {
    #triggerElement = document.querySelector(".notification");
    #parentView = document.querySelector(".notificationwindow");
    #data;
    render(data) {
        this.#data = data;
        if (Object.keys(data).length === 0) {
            const errorHTML = this._renderError();
            this._clear(this.#parentView);
            this.#parentView.insertAdjacentHTML("afterbegin", errorHTML);
            return;
        }
        this._clear(this.#parentView);
        const markup = data.map(this._generateTaskMarkup).join("");
        this.#parentView.insertAdjacentHTML("afterbegin", markup);
    }
    addhandlerStatus(handler) {
        this.#triggerElement.addEventListener("click", ()=>{
            handler(this.#parentView);
            if (this.#triggerElement.classList.contains("notify-active")) this.#triggerElement.classList.remove("notify-active");
            else this.#triggerElement.classList.add("notify-active");
        });
    }
    _generateTaskMarkup(task) {
        return `
    <div class="notifycontainer">
        <img src="images/Task.png" alt="" class="profile" width="20px" />
        <p class="notification-text">
         <b>${task.text} <span></span></b>
        </p>
      </div>`;
    }
    _renderError() {
        return `
    <div class="error">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="60px" viewBox="0 0 32 40" version="1.1" xml:space="preserve" style="" x="0px" y="0px" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><g transform="matrix(1,0,0,1,-104,0)"><g><path d="M128,12.243L115.243,25L130,25C130.347,25 130.668,24.821 130.851,24.526C131.033,24.231 131.049,23.863 130.894,23.553C130.894,23.553 129.143,20.05 128.317,18.397C128.108,17.981 128,17.521 128,17.056L128,12.243Z"/><g transform="matrix(1,0,0,1,52,0)"><path d="M71,27L65,27L65,27.002C65,27.797 65.316,28.56 65.878,29.122C66.44,29.684 67.203,30 67.998,30L68,30C68.796,30 69.559,29.684 70.121,29.121C70.684,28.559 71,27.796 71,27Z"/></g><path d="M109.65,24.936L106.293,28.293C105.903,28.683 105.903,29.317 106.293,29.707C106.683,30.097 107.317,30.097 107.707,29.707L133.707,3.707C134.098,3.317 134.098,2.683 133.707,2.293C133.317,1.903 132.683,1.903 132.293,2.293L126.801,7.785C125.556,5.781 123.45,4.368 121,4.062L121,3C121,2.448 120.552,2 120,2C119.448,2 119,2.448 119,3L119,4.062C115.054,4.554 112,7.92 112,12C112,14.765 112,15.621 112,17.056C112,17.521 111.892,17.981 111.683,18.397C110.857,20.05 109.106,23.553 109.106,23.553C108.951,23.863 108.967,24.231 109.149,24.526C109.268,24.717 109.445,24.86 109.65,24.936Z"/></g></g><text x="0" y="47" fill="#000000" font-size="5px" font-weight="bold" font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"></svg>
          <h1>
            You have no notifications!
          </h1>
        </div>`;
    }
}
var $eba8adcaf02651a4$export$2e2bcd8739ae039 = new $eba8adcaf02651a4$var$notificationView();


class $eb52bb30da7188c7$var$completed {
    #parentElement = document.querySelector(".taskView");
    addHandlerComplete(handler) {
        this.#parentElement.addEventListener("click", function(e) {
            const completeButton = e.target.closest(".complete");
            if (!completeButton) return;
            const taskElement = completeButton.closest(".task");
            const taskText = taskElement.querySelector("h1").textContent;
            completeButton.style.fill = "green";
            completeButton.style.stroke = "none";
            handler(taskText);
        });
    }
}
var $eb52bb30da7188c7$export$2e2bcd8739ae039 = new $eb52bb30da7188c7$var$completed();



var $dba2eee0ac013f2e$exports = {};
$dba2eee0ac013f2e$exports = new URL("noun-correct-4644680.bb3937c7.png", import.meta.url).toString();


class $7053429662d1744b$var$completeView extends (0, $d56741b663388f29$export$2e2bcd8739ae039) {
    #triggerElement = document.querySelector("#completed");
    #data;
    addHandlerComplete(handler) {
        this.#triggerElement.addEventListener("click", function() {
            handler();
        });
    }
    _generateTaskMarkup(task) {
        return `
    
          <div class="task">
            <div class="icons">
             <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              x="0px"
              y="0px"
              viewBox="-5.0 -10.0 110.0 135.0"
              enable-background="new 0 0 100 100"
              xml:space="preserve"
              stroke="none"
              fill="green"
              stroke-width="8px"
              width="30px"
              height="30px"
              class="complete"
            >
              <path
                d="M50,3C24.0844097,3,3,24.0844097,3,50s21.0844097,47,47,47c25.9163284,0,47-21.0844116,47-47S75.9163284,3,50,3z   M75.7727127,37.8906784L47.1550369,68.4529037C46.2999954,69.3627243,45.1081161,70,43.8592339,70  c-0.0059242,0-0.0125847,0-0.0185204,0c-1.2422066,0-2.4303856-0.6215439-3.2883873-1.5195236L24.2539387,51.3671761  c-1.7352581-1.8166885-1.6701126-4.7241325,0.1458378-6.4593887c1.8166904-1.7337761,4.6964474-1.6836281,6.4309635,0.1315804  l12.9825954,13.5796394l25.3292732-26.9548759c1.7204514-1.8285351,4.5972443-1.9243584,6.4302216-0.2009449  C77.4028473,33.1836357,77.491684,36.0599213,75.7727127,37.8906784z"
              />
            </svg>
            </div>
            <h1>${task.text}</h1>
          </div>
     `;
    }
    _renderError() {
        return `
    <div class="error">
          <img src="${0, (/*@__PURE__*/$parcel$interopDefault($dba2eee0ac013f2e$exports))}" alt="" width="100px" />
          <h1>
            You haven't completed<br />
            any tasks yet!
          </h1>
        </div>`;
    }
}
var $7053429662d1744b$export$2e2bcd8739ae039 = new $7053429662d1744b$var$completeView();



var $a616764c254b4e48$exports = {};
$a616764c254b4e48$exports = new URL("noun-history-4644679.b9f521a2.png", import.meta.url).toString();


class $b8762e99bf0d47a8$var$pendingView extends (0, $d56741b663388f29$export$2e2bcd8739ae039) {
    #triggerElement = document.querySelector("#pending");
    #data;
    addHandlerPending(handler) {
        this.#triggerElement.addEventListener("click", function() {
            handler();
        });
    }
    _generateTaskMarkup(task) {
        return `
    
          <div class="task">
            <div class="icons">
             <svg xmlns:x="http://ns.adobe.com/Extensibility/1.0/" xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/" xmlns:graph="http://ns.adobe.com/Graphs/1.0/" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 125" style="enable-background:new 0 0 100 100;" fill="orange" width="30px"
              height="30px" xml:space="preserve"><switch><foreignObject requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" x="0" y="0" width="1" height="1"/><g i:extraneous="self"><g><path d="M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z"/><path d="M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z"/><path d="M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z"/><path d="M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z"/></g><path d="M50,2.5C23.8,2.5,2.5,23.8,2.5,50c0,26.2,21.3,47.5,47.5,47.5S97.5,76.2,97.5,50C97.5,23.8,76.2,2.5,50,2.5z M70.1,55.3    H50c-2.9,0-5.3-2.4-5.3-5.3V25.3c0-2.9,2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3v19.5h14.8c2.9,0,5.3,2.4,5.3,5.3    C75.4,52.9,73,55.3,70.1,55.3z"/></g></switch></svg>
            </div>
            <h1>${task.text}</h1>
          </div>
     `;
    }
    _renderError() {
        return `
    <div class="error">
          <img src="${0, (/*@__PURE__*/$parcel$interopDefault($a616764c254b4e48$exports))}" alt="" width="100px" />
          <h1>
            You don't haved<br />
            any pending task!
          </h1>
        </div>`;
    }
}
var $b8762e99bf0d47a8$export$2e2bcd8739ae039 = new $b8762e99bf0d47a8$var$pendingView();



var $4aad11bac7c78317$exports = {};
$4aad11bac7c78317$exports = new URL("Close.b277ea6d.png", import.meta.url).toString();


class $ab38a1fe7b7abe76$var$DescriptionView extends (0, $d56741b663388f29$export$2e2bcd8739ae039) {
    // Override parent element to be `document.body`
    #parentElement = document.body;
    #data = [];
    // Add handler to show description view
    addHandlershow(handler) {
        this.#parentElement.addEventListener("click", (e)=>{
            if (e.target.classList.contains("delete") || e.target.classList.contains("complete")) return;
            const task = e.target.closest(".task");
            if (!task) return;
            const taskMarkup = task.querySelector("h1").innerHTML;
            handler(taskMarkup);
        });
    }
    render(data) {
        this.#data = data;
        const markup = this.#data.map(this._generateTaskMarkup).join("");
        this.#parentElement.insertAdjacentHTML("afterbegin", markup);
        this._addHandlerCloseButton();
    }
    _generateTaskMarkup(task) {
        return `
      <div class="taskDescription">
        <form class="formcontainer">
          <img src="${0, (/*@__PURE__*/$parcel$interopDefault($4aad11bac7c78317$exports))}" alt="close" class="close" />
          <h1>Task Description</h1>
          <input
            type="text"
            name="text"
            placeholder="Enter the Task"
            value="${task.text}"
            disabled
          />
          <textarea
            name="description"
            cols="30"
            rows="10"
            placeholder="Add a little description"
            disabled
          >${task.description}</textarea>
        </form>
      </div>
    `;
    }
    _addHandlerCloseButton() {
        this.#parentElement.addEventListener("click", (e)=>{
            const closeButton = e.target.closest(".close");
            if (!closeButton) return;
            const parentElement = closeButton.closest(".taskDescription");
            parentElement.remove();
        });
    }
    // Clear method to clear the target element's content
    _clear(element) {
        element.innerHTML = "";
    }
}
var $ab38a1fe7b7abe76$export$2e2bcd8739ae039 = new $ab38a1fe7b7abe76$var$DescriptionView();


const $d63a8266effe4d07$var$more = document.querySelector(".more");
const $d63a8266effe4d07$var$controlHiddenStatus = function(element) {
    $d7fcaaa29d0ffaa7$export$9a487a26f79786f3(element);
};
const $d63a8266effe4d07$var$controlAddTask = function(task) {
    $d7fcaaa29d0ffaa7$export$a4281dcfe4be938d(task);
    (0, $d81f96baf221c9f7$export$2e2bcd8739ae039).render($d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists);
    (0, $e659f5f158f1f197$export$2e2bcd8739ae039).addHandlerDelete($d63a8266effe4d07$var$controlDeleteTask);
};
const $d63a8266effe4d07$var$controlDeleteView = function() {
    (0, $dccd2ef3a9b1f20b$export$2e2bcd8739ae039).render($d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.recentDeleted);
};
const $d63a8266effe4d07$var$controlAllViews = function() {
    (0, $d81f96baf221c9f7$export$2e2bcd8739ae039).render($d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists);
};
const $d63a8266effe4d07$var$controlLoad = function() {
    (0, $d81f96baf221c9f7$export$2e2bcd8739ae039).render($d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists);
};
const $d63a8266effe4d07$var$controlDeleteTask = function(markup) {
    $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.find((task)=>{
        if (task.text === markup) $d7fcaaa29d0ffaa7$export$f08d315250e1aa23(task.id);
    });
    (0, $d81f96baf221c9f7$export$2e2bcd8739ae039).render($d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists);
};
const $d63a8266effe4d07$var$controlCompleteTask = function(markup) {
    $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.find((task)=>{
        if (task.text === markup) $d7fcaaa29d0ffaa7$export$f9b8f6c708100712(task);
    });
};
const $d63a8266effe4d07$var$controlDescriptionView = function(markup) {
    const filterFromDeleted = $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.recentDeleted.filter((task)=>task.text === markup);
    const letSee = filterFromDeleted.length === 0 ? $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.filter((task)=>task.text === markup) : filterFromDeleted;
    (0, $ab38a1fe7b7abe76$export$2e2bcd8739ae039).render(letSee);
};
const $d63a8266effe4d07$var$controlCompletedView = function() {
    const completedArray = $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.filter((task)=>task.completed === true);
    (0, $7053429662d1744b$export$2e2bcd8739ae039).render(completedArray);
};
const $d63a8266effe4d07$var$controlPendingView = function() {
    const pendingarray = $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.filter((task)=>task.pending === true);
    (0, $b8762e99bf0d47a8$export$2e2bcd8739ae039).render(pendingarray);
};
const $d63a8266effe4d07$var$controlNotificationView = function() {
    const pendingNotifications = $d7fcaaa29d0ffaa7$export$4ed7a3435bd201be.taskLists.filter($d7fcaaa29d0ffaa7$export$2adf6238a2d0dafa);
    (0, $eba8adcaf02651a4$export$2e2bcd8739ae039).render(pendingNotifications);
};
const $d63a8266effe4d07$var$init = function() {
    (0, $bee5f140897ff5dc$export$2e2bcd8739ae039).addhandlerClick($d63a8266effe4d07$var$controlHiddenStatus);
    (0, $eba8adcaf02651a4$export$2e2bcd8739ae039).addhandlerStatus($d63a8266effe4d07$var$controlHiddenStatus);
    (0, $bee5f140897ff5dc$export$2e2bcd8739ae039).addTaskHandler($d63a8266effe4d07$var$controlAddTask);
    (0, $e659f5f158f1f197$export$2e2bcd8739ae039).addHandlerDelete($d63a8266effe4d07$var$controlDeleteTask);
    (0, $eea0cfd44b04b5f1$export$2e2bcd8739ae039).addhandlerClick();
    (0, $d81f96baf221c9f7$export$2e2bcd8739ae039).addHandlerAll($d63a8266effe4d07$var$controlAllViews);
    (0, $dccd2ef3a9b1f20b$export$2e2bcd8739ae039).addHandlerDelete($d63a8266effe4d07$var$controlDeleteView);
    (0, $d81f96baf221c9f7$export$2e2bcd8739ae039).addHandlerLoad($d63a8266effe4d07$var$controlLoad);
    (0, $eb52bb30da7188c7$export$2e2bcd8739ae039).addHandlerComplete($d63a8266effe4d07$var$controlCompleteTask);
    (0, $7053429662d1744b$export$2e2bcd8739ae039).addHandlerComplete($d63a8266effe4d07$var$controlCompletedView);
    (0, $b8762e99bf0d47a8$export$2e2bcd8739ae039).addHandlerPending($d63a8266effe4d07$var$controlPendingView);
    (0, $eba8adcaf02651a4$export$2e2bcd8739ae039).addhandlerStatus($d63a8266effe4d07$var$controlNotificationView);
    (0, $ab38a1fe7b7abe76$export$2e2bcd8739ae039).addHandlershow($d63a8266effe4d07$var$controlDescriptionView);
};
$d63a8266effe4d07$var$init();


//# sourceMappingURL=index.207b4de4.js.map
